export const cardActionAreaDefaultStyle = theme => ({
  '&:focus-visible .MuiCard-root': {
    boxShadow: theme.tokens.ComponentCardBoxShadow
  },
  '.MuiCardActionArea-focusHighlight': {
    display: 'none'
  }
});
const cardDefaultStyle = (theme, width) => ({
  backgroundColor: theme.tokens.ComponentCardBg,
  border: `1px solid ${theme.tokens.ComponentCardBorderColor}`,
  '&.MuiCard-root': {
    borderRadius: theme.tokens.ComponentCardBorderRadius,
    height: '100%',
    width: width ? width : '100%'
  }
});
export default cardDefaultStyle;